import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { StoreState } from '../../../../reducers';
import { ImportFileState } from '../../../../containers/ImportManager/reducer';
import { cancelFileImport, restartFilesImport } from '../../../../containers/ImportManager/actions';
import ProgressCircle from '../../../ProgressCircle';
import {
	StyledListItem,
	FileIcon,
	FileLabel,
	FileStatus,
	StatusDone,
	StatusError,
	ButtonRestart,
	ButtonFileCancel,
} from '../styles';
import Utils from '../../../../utils';

interface ListItemProps {
	file: ImportFileState;
	dispatch: Dispatch<StoreState>;
}

const getFileIconName = (fileType: string): string => {
	if (fileType.includes('image')) {
		return 'iconset_gallery-bold';
	} else if (fileType.includes('video')) {
		return 'iconset_video-bold';
	} else {
		return 'iconset_uprez_file';
	}
};

const getFileStatus = ({
	id,
	percentage,
	error,
	isImportCanceled,
	isImportFinished,
// tslint:disable-next-line: align
}: ImportFileState, dispatch: Dispatch<StoreState>): React.ReactNode => {
	if (error) {
		return (
			<StatusError>
				<Translate value="messages.error" />
				{Utils.getSvgIcon('iconset_uprez_info2')}
			</StatusError>
		);
	} else if (isImportFinished) {
		return (
			<StatusDone>
				{Utils.getSvgIcon('iconset_uprez_check_circle')}
			</StatusDone>
		);
	} else if (isImportCanceled) {
		return (
			<ButtonRestart
				type="button"
				onClick={() => dispatch(restartFilesImport([id as string]))}
			>
				<Translate value="messages.restart" />
				{Utils.getSvgIcon('iconset_uprez_refresh')}
			</ButtonRestart>
		);
	} else {
		return (
			<ProgressCircle
				size={20}
				strokeWidth={2}
				percentage={percentage as number}
			/>
		);
	}
};

const ListItem = ({ file, dispatch }: ListItemProps) => {
	const {
		id,
		file: source,
		error,
		isImportCanceled,
		isImportFinished,
	} = file;
	const isCancelEnabled = !error && !isImportCanceled && !isImportFinished;

	return (
		<StyledListItem>
			<FileIcon>
				{Utils.getSvgIcon(getFileIconName(source!.type))}
			</FileIcon>
			<FileLabel>{source!.name}</FileLabel>
			<FileStatus>
				{getFileStatus(file, dispatch)}
				{isCancelEnabled &&
					<ButtonFileCancel
						type="button"
						onClick={() => dispatch(cancelFileImport(id as string))}
					>
						{Utils.getSvgIcon('iconset_close-2')}
					</ButtonFileCancel>
				}
			</FileStatus>
		</StyledListItem>
	);
};

export default React.memo(ListItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ImportDesktopFile/Toast/ListItem/index.tsx